import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { createAction } from '../../interfaces';
import categoryService from '../../services/category';
import * as definitions from '../../definitions/category';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var categoryActionCreators = {
  getCategoriesAction: function getCategoriesAction() {
    return createAction(definitions.GET_CATEGORIES);
  },
  getCategoriesSuccess: function getCategoriesSuccess(categories) {
    return createAction(definitions.GET_CATEGORIES_SUCCESS, categories);
  },
  getUserCategoriesFail: function getUserCategoriesFail(error) {
    return createAction(definitions.GET_CATEGORIES_FAIL, error);
  }
};
export var getCategories = function getCategories() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getCategoriesAction, getCategoriesSuccess, getUserCategoriesFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getCategoriesAction = categoryActionCreators.getCategoriesAction, getCategoriesSuccess = categoryActionCreators.getCategoriesSuccess, getUserCategoriesFail = categoryActionCreators.getUserCategoriesFail;
              dispatch(getCategoriesAction());
              return _context.abrupt("return", categoryService.getCategories().then(function (categories) {
                dispatch(getCategoriesSuccess(categories));
                return true;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUserCategoriesFail(message));
                handleErrorResponse(error, dispatch);
                return false;
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};